<template>
  <div>
    <!-- Corpo -->
    <div class="bg-white rounded-lg shadow-md p-4 mb-3">
      <div class="flex justify-center">
        <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
      </div>
    </div>
    <div class="bg-white rounded-lg pulse-red-border p-2 mb-3">
      <h1 class="text-center text-xl font-bold text-red-500">{{ contextualMessage }}</h1>
    </div>
    <form @submit.prevent="submitForm()">
      <div class="px-6 pb-0">
        <div class="grid grid-cols-2 bg-white rounded-md shadow-lg px-4 py-2">
          <div class="p-4">
            <div class="mb-4 pb-3">
              <input type="text" v-model="currentDateTime" class="p93__input w-full" readonly />
              <div v-if="form.errors.date_time" class="text-red-500 text-sm pt-2">{{ form.errors.date_time }}</div>
            </div>
            <div class="grid grid-cols-2">
              <div class="p-0 pr-2">
                <div class="mb-4 pb-3">
                  <video id="webcam-preview" autoplay playsinline class="w-full max-w-md rounded-md shadow-lg border" style="transform: scaleX(-1)"></video>
                </div>
              </div>
              <div class="p-0 pl-2">
                <div class="mb-4 pb-3">
                  <QrcodeStream @detect="onDetect" class="w-full max-w-md hidden" />
                  <input id="barcode" type="text" @focus="isTextInputFocused = true" @blur="isTextInputFocused = false" v-model="form.badge" @input="searchVisitor" placeholder="Badge"
                    :class="['p93__input', 'w-full', { 'pulse-red-border': shouldHighlightBadge }]" required />
                  <div v-if="!badgeIsActive && form.badge" class="text-red-500 text-sm pt-2">Badge non valido o scaduto</div>
                  <div v-if="!badgeExists && form.badge" class="text-red-500 text-sm pt-2">Badge non trovato</div>
                  <div v-if="form.errors.badge" class="text-red-500 text-sm pt-2">{{ form.errors.badge }}</div>
                  <video id="barcode-scanner" class="hidden"></video>
                </div>
                <div class="mb-4 pb-3">
                  <input type="text" @focus="isTextInputFocused = true" @blur="isTextInputFocused = false" v-model="form.name" 
                    :class="['p93__input', 'w-full', { 'pulse-red-border': shouldHighlightName }]" 
                    placeholder="Nominativo" required />
                  <div v-if="form.errors.name" class="text-red-500 text-sm pt-2">{{ form.errors.name }}</div>
                </div>
                <div class="mb-4 pb-3">
                  <input type="text" @focus="isTextInputFocused = true" @blur="isTextInputFocused = false" v-model="form.company" 
                    :class="['p93__input', 'w-full', { 'pulse-red-border': shouldHighlightCompany }]" 
                    placeholder="Azienda" required />
                  <div v-if="form.errors.company" class="text-red-500 text-sm pt-2">{{ form.errors.company }}</div>
                </div>
              </div>
            </div>
            
            <div class="mb-4 pb-2">
              <v-select
                :searchable="false"
                placeholder="Con chi hai appuntamento?"
                label="name"
                v-model="form.contact"
                :options="contacts"
                :clearable="false"
                :class="{ 'pulse-red-border': shouldHighlightContact }"
                required
              ></v-select>
              <!--<select v-model="form.contact" :class="{ 'pulse-red-border': shouldHighlightContact }" class="p93__input" required>
                <option value="" disabled selected>Con chi hai appuntamento?</option>
                <option v-for="contact in contacts" :key="contact.id" :value="contact">{{ contact.name }}</option>
              </select>-->
              <div v-if="form.errors.contact_id" class="text-red-500 text-sm pt-2">{{ form.errors.contact_id }}</div>
            </div>
          </div>
          <div class="p-4">
            <div class="mb-4">
              <label for="infoEmergenza" class="flex items-center cursor-pointer">
                <input id="infoEmergenza" type="checkbox" v-model="form.registro_emergenza" class="sr-only"
                  @click="(event) => openEmergencyInfoModal(event.target.checked)" />
                <div class="relative w-10 h-5 bg-gray-300 rounded-full transition-colors duration-200"
                  :class="[
                    { 'bg-green-500': form.registro_emergenza },
                    { 'pulse-red-border': shouldHighlightEmergency }
                  ]">
                  <span
                    class="absolute left-0 top-0 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-200"
                    :class="{ 'translate-x-5': form.registro_emergenza }" />
                </div>
                <button type="button" @click="openEmergencyInfoModal" 
                  :class="['ml-4 text-blue-500 decoration-dotted', { 'pulse-red-border': shouldHighlightEmergency }]">Info
                  Emergenza</button>
              </label>
              <div v-if="form.errors.registro_emergenza" class="text-red-500 text-sm pt-2">{{
                form.errors.registro_emergenza }}
              </div>
            </div>
            <div class="mb-4">
              <p class="text-sm mt-2 mb-8">
                * Con la spunta del pulsante sopra indicato si conferma di aver preso visione e ricevuto le informazioni di
                emergenza
              </p>
            </div>
            <div class="mb-4">
              <label class="font-bold">Firma:</label>
              <VueSignaturePad v-if="!signature" ref="signaturePad" width="100%" height="145px" :options="{ penColor: 'black', onEnd }"
                :class="['rounded-md shadow-lg border mt-2', { 'pulse-red-border': shouldHighlightSignature }]" />
              <div v-if="signature" class="rounded-md shadow-lg border mt-2" style="width: 100%; height: 145px; display: flex; align-items: center; justify-content: center; background-color: #f9f9f9;">
                <img :src="signature" alt="Firma" class="max-w-full max-h-full object-contain" />
              </div>
              <div v-if="signatureError" class="text-red-500 text-sm pt-2">Firma necessaria!</div>
              <div v-if="form.errors.signature" class="text-red-500 text-sm pt-2">{{ form.errors.signature }}</div>
              <div class="flex justify-between mt-5">
                <Link :href="route('modules.home', { slug: 'reception-digitale' })"
                  class="bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-md flex items-center border">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                  </svg>
                  Torna indietro
                </Link>
                <button @click="clearSignature" type="button"
                  class="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-md flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Cancella firma
                </button>
                <button type="submit"
                  class="bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-4 py-2 rounded-md flex items-center" :disabled="isSubmitting">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Registra visitatore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Modale Info Emergenza -->
    <EmergencyInfoModal 
      :visible="showEmergencyInfoModal" 
      :customer-slug="customerSlug" 
      @close="closeEmergencyInfoModal" 
    />

    <ModalMessage
      v-if="showCheckin"
      :visible="showCheckin"
      title="Ingresso registrato con successo!"
      :messages="['Ricordati di registrare il badge in uscita.', 'Buona permanenza!']"
      @close="resetForm"
    />
    <ModalMessage
      v-if="showCheckout"
      :visible="showCheckout"
      title="Uscita Registrata con successo!"
      :messages="[
        `La tua visita è durata ${visitDuration}.`,
        'Ci auguriamo che la permanenza sia stata piacevole!'
      ]"
      @close="resetForm"
    />
  </div>
</template>

<script>
import { Link, useForm, usePage, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import { format } from 'date-fns';
import { VueSignaturePad } from 'vue-signature-pad';
import { QrcodeStream } from 'vue-qrcode-reader';
import ModalMessage from '@/Components/ModalMessage.vue';
import EmergencyInfoModal from '@/Components/EmergencyInfoModal.vue';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';

export default {
  props: ['errors', 'visitor', 'badge', 'contacts', 'badgeIsActive', 'badgeExists', 'visit', 'customer', 'frequentAccess', 'badgeVisitError', 'registro_letto'],
  components: {
    Link,
    BreadCrumbs,
    VueSignaturePad,
    QrcodeStream,
    ModalMessage,
    EmergencyInfoModal
  },
  layout: LayoutNoHeader, // Usa il layout senza header
  data() {
    return {
      customerSlug: null,
      form: useForm({
        date_time: null,
        name: null,
        company: null,
        badge: null,
        registro_emergenza: false,
        contact_id: null,
        contact: '',
        signature: null,
      }),
      currentDateTime: '',
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
        { name: 'Ingresso', href: route('modules.rd-ingresso') }
      ],
      dateFormat: 'yyyy-MM-dd',
      searchContactBy: null,
      showEmergencyInfoModal: false,
      emergencyInfoOpened: false,
      signatureError: false,
      showCheckin: false,
      showCheckout: false,
      visitDuration: null,
      barcode: null,
      isTextInputFocused: false,
      isSubmitting: false,
      signature: false
    };
  },
  computed: {
    contextualMessage() {
      // Check for error states first
      if (!this.badgeIsActive && this.form.badge) {
        return "Badge non valido o scaduto. Contattare la reception.";
      }
      
      if (!this.badgeExists && this.form.badge) {
        return "Badge non trovato. Verificare il codice o contattare la reception.";
      }

      if (this.badgeVisitError) {
        return "Il badge risulta già in uso da altro utente.";
      }

      if (this.form.badge && (!this.form.name || !this.form.company)) {
        return "Inserire il proprio Nominativo e il nome dell’Azienda";
      }

      if (this.form.name && this.form.company && this.form.badge && this.isTextInputFocused) {
        return "A compilazione conclusa, tocca ↵, x nel riquadro della tastiera in cima a destra o in uno spazio vuoto per confermare";
      }

      if (this.form.name && this.form.company && this.form.badge && !this.form.contact) {
        return "Inserire il referente del proprio appuntamento";
      }

      if (this.form.name && this.form.company && this.form.badge && this.form.contact && !this.form.registro_emergenza) {
        return "Leggere le \"Info Emergenza\" qui sotto e confermare";
      }

      if (this.form.name && this.form.company && this.form.badge && this.form.contact && this.form.registro_emergenza && !this.form.signature) {
        return "Firmare nell'apposito spazio e registrarsi";
      }

      if (this.form.name && this.form.company && this.form.badge && this.form.contact && this.form.registro_emergenza && this.form.signature) {
        return "Procedere con la registrazione";
      }
      
      // Default messages based on access type
      if (this.frequentAccess) {
        return "Mostrare il proprio QR Code alla telecamera";
      }
      
      return "Prendere qui accanto un badge disponibile e mostrarlo alla telecamera";
    },
    customerEmergencyInfo() {
      return this.emergencyInfoByCustomer[this.customerSlug] || this.emergencyInfoByCustomer['default'];
    },
    shouldHighlightBadge() {
      return !this.form.badge;
    },
    shouldHighlightName() {
      return this.form.badge && !this.form.name && this.badgeIsActive && this.badgeExists;
    },
    shouldHighlightCompany() {
      return this.form.badge && this.form.name && !this.form.company && this.badgeIsActive && this.badgeExists;
    },
    shouldHighlightContact() {
      return this.form.badge && this.form.name && this.form.company && !this.form.contact && this.badgeIsActive && this.badgeExists;
    },
    shouldHighlightEmergency() {
      return this.form.badge && this.form.name && this.form.company && this.form.contact && !this.form.registro_emergenza && this.badgeIsActive && this.badgeExists;
    },
    shouldHighlightSignature() {
      return this.form.badge && this.form.name && this.form.company && this.form.contact && this.form.registro_emergenza && !this.form.signature && this.badgeIsActive && this.badgeExists;
    }
  },
  mounted() {
    const page = usePage();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    this.startWebcam(); // Start the webcam feed
    this.customerSlug = page.props.customer?.slug;
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDateTime = format(now, 'dd/MM/yyyy HH:mm:ss');
      this.form.date_time = now.toISOString();
    },
    submitForm() {
      this.isSubmitting = true;
      this.form.contact_id = (this.form.contact_id === null || this.form.contact_id === undefined) ? this.form.contact?.id : this.form.contact_id;
      this.form.post(route('modules.rd-nuovo-ingresso'), {
        only: ['visit'],
        preserveState: true,
        preserveScroll: true,
        replace: true,
        onSuccess: (page) => {
          if (page.props.visit.check_in && !page.props.visit.check_out) {
            router.visit(route('modules.rd-attesa-referente', { visit: page.props.visit.id }));
          } else if (page.props.visit.check_in && page.props.visit.check_out) {
            const durationInMinutes = page.props.visit.duration;
            const hours = Math.floor(durationInMinutes / 60);
            const minutes = durationInMinutes % 60;
            this.visitDuration = `${hours} ore e ${minutes} minuti`;
            this.showCheckout = true;
          }
        },
        onFinish: () => {
          this.isSubmitting = false;
        }
      });
    },
    setVisitorData(visitor) {
      this.form.name = visitor?.name;
      this.form.company = visitor?.company;
    },
    searchVisitor() {
      if (this.form.badge.length >= 3) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          router.get(route('modules.rd-ingresso'), {
            badge: this.form.badge,
            search: this.searchVisitorBy
          }, {
            preserveState: true,
            only: ['visitor', 'badgeIsActive', 'badgeExists', 'badgeVisitError', 'registro_letto'],
            onSuccess: (page) => {
              this.setVisitorData(page.props.visitor);
              if (page.props.badgeVisitError) {
                this.form.badge = '';
              }
              if (page.props.registro_letto) {
                //La firma va richiesta sempre e comunque (averla messa una volta non fa più comparire l'emergenza)
                //this.form.signature = page.props.signature;
                this.form.registro_emergenza = true;
              }
            }
          });
        }, 300);
      }
    },
    openEmergencyInfoModal(checked) {
      if (checked !== undefined && checked) {
        this.showEmergencyInfoModal = true;
        return;
      }
    },
    closeEmergencyInfoModal() {
      this.showEmergencyInfoModal = false;
      this.emergencyInfoOpened = true;
      this.form.registro_emergenza = true;
    },
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
      this.form.signature = null;
    },
    resetForm() {
      router.get(route('modules.rd-ingresso'));
    },
    onEnd() {
      this.checkSignature();
    },
    checkSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.form.signature = data;
      this.signatureError = isEmpty || data.length < 10000;
    },
    toggleRegistroEmergenza() {
      this.form.registro_emergenza = !this.form.registro_emergenza;
    },
    onDetect(codes) {
      if (codes.length > 0) {
        this.form.badge = codes[0].rawValue; // Popola il campo con il valore scansionato
        this.searchVisitor();
      }
    },
    startWebcam() {
      const videoElement = document.getElementById('webcam-preview');
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true })
          .then((stream) => {
            videoElement.srcObject = stream;
          })
          .catch((error) => {
            console.error('Error accessing webcam:', error);
          });
      }
    }
  },
  watch: {
    visitor(value) {
      this.form.name = value?.name;
      this.form.company = value?.company;
    }
  }
};
</script>